<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h4 qid="view-org-name">
              {{ organization.name }}
            </h4>
            <div class="mb-2">
              <span v-if="getGuide('organization')">
                <GuideButton :guide="getGuide('organization')"></GuideButton>
              </span>
            </div>
          </div>

          <div class="col-md-6 text-right" qid="view-org-modified">
            <div class="mb-4">
              <span class="h6 ml-3">
                <span v-if="isGranted([permissions.ORGANIZATION_EDIT, permissions.ORGANIZATION_EDIT_OWN], organization.created_by) && (!getClient.parent || (getClient.parent && organization.partition))"
                      class="btn btn-edit"
                      qid="edit-org-button"
                      @click="showEditTPModal(organization)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                    <span v-if="isGranted([permissions.ORGANIZATION_DELETE, permissions.ORGANIZATION_DELETE_OWN], organization.created_by) && (!getClient.parent || (getClient.parent && organization.partition))"
                          class="btn btn-delete"
                          qid="delete-org-button"
                          @click="showConfirmDeleteModal(organization)"
                    >
                  <font-awesome-icon icon="trash-alt"/>
                </span>
              </span>
            </div>
            <div>
              <span qid="view-org-modified">{{ $t('table.last_updated') }}</span>
              <span class="ml-2 text-muted small" qid="view-org-modified-date">
                {{ organization.updated_at | formatDate }}
              </span>
              <Avatar v-if="organization.updated_by" :object="organization.updated_by" size="xs" class="ml-3 mr-2"></Avatar>
              <span v-if="organization.updated_by" qid="view-org-modified-by">
                {{ organization.updated_by.name }}
              </span>
            </div>
          </div>

        </div>

        <hr />
        <div class="content-view-body">
          <br />
          <div>
            <p class="text-dark">
              {{ $t('maintenance.organizations.create.description_label') }}
            </p>
            <hr>
            <p class="text-formatted" qid="organization-description">
              {{ organization.description }}
            </p>
            <br>
          </div>
          <div>
            <p class="text-dark">
              {{ $t('maintenance.organizations.create.organization_level_label') }}
            </p>
            <hr>
            <p>
              <span class="badge badge-info"
                    v-if="organization.organization_level"
                    qid="organization-level"
              >
                {{ $t('system.level') }} {{ organization.organization_level }}
              </span>
            </p>
            <br>
          </div>
          <div>
            <p class="text-dark">
              {{ $t('maintenance.organizations.create.link_organization_label') }}
            </p>
            <hr>
            <p qid="organization-linked-organization">
              <router-link
                  v-if="organization.linkedOrganization"
                  :to="{ name: 'maintenance.organizations.view', params: { slug: organization.linkedOrganization.slug }}"
                  qid="view-org-link-organization"
              >
                {{ organization.linkedOrganization.name }}
              </router-link>
            </p>
            <br>
          </div>
          <div>
            <p class="text-dark">
              {{ $t('maintenance.organizations.create.members_label') }}
            </p>
            <hr>
            <div v-for="(user, index) in organization.users" class="mt-1 mb-1">
              <div class="row">
                <div class="col-sm-10">
                  <Avatar :object="user" size="xs" :noOwner="true"></Avatar>
                  <span class="ml-2">{{ user.name }}</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


    <!-- Edit third party modal template -->
    <b-modal ref="edit-organization" hide-footer>
      <div class="d-block text-center">
        <h4 qid="update-org-title">
          {{ $t('maintenance.organizations.update.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-org-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editTPFormSubmit" qid="edit-org-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-org-name-label">
              {{ $t('maintenance.organizations.create.name_label') }}
            </label>
            <b-form-input
                qid="edit-org-form-name"
                type="text"
                v-model="tpForm.name"
                :maxLength="255"
                required
                :placeholder="$t('maintenance.organizations.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-org-description-label">
              {{ $t('maintenance.organizations.create.description_label') }}
            </label>
            <b-form-textarea
                qid="edit-org-form-description"
                v-model="tpForm.description"
                rows="6"
                max-rows="6"
                :placeholder="$t('maintenance.organizations.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="edit-org-organization-level-label">
              {{ $t('maintenance.organizations.create.organization_level_label') }}
            </label>
            <multiselect
                v-model="tpForm.organization_level"
                :options="levelItems"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('maintenance.organizations.create.organization_level_placeholder')"
                label="name"
                qid="edit-org-form-organization-level"
                @select="selectLevel"
                @remove="removeLevel"
            ></multiselect>
          </b-form-group>
          <b-form-group ref="select-link-organization" :class="{'d-none':!showLinkOrganizations}">
            <label qid="edit-org-link-organization-label">
              {{ $t('maintenance.organizations.create.link_organization_label') }}
            </label>
            <multiselect
                v-model="tpForm.link_organization"
                :options="organizations"
                track-by="id"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="debounceOrganizations"
                :placeholder="$t('maintenance.organizations.create.link_organization_placeholder')"
                label="name"
                qid="edit-org-link-organization-select"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-p-users-label">
              {{ $t('maintenance.organizations.create.members_label') }}
            </label>
            <multiselect
                    v-model="selectedUsers"
                    :options="users"
                    :multiple="true"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :taggable="false"
                    @search-change="loadUsers"
                    track-by="slug"
                    :placeholder="$t('maintenance.organizations.create.members_placeholder')"
                    label="name"
                    qid="create-p-users-select"
            >
              <template slot="tag" slot-scope="props">
                <span class="mr-3 user-tag">
                  <Avatar :object="props.option" size="xs"></Avatar>
                  <span class="ml-2">{{ props.option.name }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditTPModal"
                    qid="edit-org-cancel-button"
          >
            {{ $t('maintenance.organizations.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-org-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.organizations.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Delete third party confirm modal template -->
    <b-modal ref="delete-organizations" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-org-title">
          {{ $t('maintenance.organizations.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.organizations.delete.description') }} {{ itemToDelete.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('maintenance.organizations.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmDeleteModal"
                  qid="delete-org-cancel-button"
        >
          {{ $t('maintenance.organizations.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteTP(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-org-submit-button"
                  v-if="isGranted([permissions.ORGANIZATION_DELETE, permissions.ORGANIZATION_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
        >
          {{ $t('maintenance.organizations.delete.submit') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js'
import {config} from '@/config.js'
import Avatar from '@/components/Avatar.vue';
import GuideButton from '@/components/guide/GuideButton.vue';


export default {
  name: 'OrganizationView',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('maintenance.title'),
          to: '/maintenance'
        },
        {
          text: this.$t('maintenance.organizations.title'),
          to: '/maintenance/organizations'
        }
      ],
      organization: {},
      showInput: false,
      showSingleLinkLabel: true,
      inputLink: '',
      itemToDelete: {},
      tpForm: {
        name: '',
        description: '',
        organization_level: '',
        link_organization: '',
        users: [],
        client:'',
      },
      error: '',
      levelItems: [
        { name: this.$t('system.level') + ' 1', value: '1' },
        { name: this.$t('system.level') + ' 2', value: '2' },
        { name: this.$t('system.level') + ' 3', value: '3' },
        { name: this.$t('system.level') + ' 4', value: '4' },
        { name: this.$t('system.level') + ' 5', value: '5' }
      ],
      organizations: [],
      selectedUsers: [],
      users: [],
      showLinkOrganizations: false,
      buttonDisabled: false,
      myGuides: [],
    }
  },
  computed: {
    getClient() {
      return this.$store.state.client
    }
  },
  watch: {
    getClient: function (newValue, oldValue) {
      if (newValue && oldValue && newValue.slug !== oldValue.slug) {
        this.goToList()
      }
    }
  },
  components: {
    Avatar,
    GuideButton
  },
  methods: {
    goToList() {
      this.$router.push('/maintenance/organizations')
    },
    debounceOrganizations: _.debounce(function(query) {
      this.asyncLoadLinkOrganizations(query)
    }, 400),
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function(object) {
        return object.scope == code && object.type == 'Maintenance' && object.enabled
      });
      return existingGuide
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          type: 'Maintenance',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
        }
      }, function() {});
    },
    selectLevel(selectedOption) {
      this.tpForm.organization_level = selectedOption
      if (selectedOption && selectedOption.value != 1) {
        this.showLinkOrganizations = true;
      } else {
        this.showLinkOrganizations = false;
      }
      this.asyncLoadLinkOrganizations()
    },
    removeLevel() {
      this.tpForm.link_organization = ''
      this.showLinkOrganizations = false
      this.tpForm.organization_level = ''
    },
    asyncLoadLinkOrganizations(query) {
      let self = this;
      piincHttp.get('organizations', { params:
        {
          smaller_then_organization_level: this.tpForm.organization_level.value,
          keyword: query ? query : undefined,
          exclude_organization: this.organization.id,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.organizations = response.data.items;
        }
      }, function() {});

    },
    loadContent(breadcrumbPush) {
      let self = this;
      piincHttp.get('organizations/' + this.$route.params.slug, { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.organization = response.data;
        if (breadcrumbPush) {
          // Push Third party name in breadcrumb array
          self.breadcrumbItems.push({text: self.organization.name, active: true});
        }
      }, function() {});
    },
    getUserAvatar(user){
      if(user && user.avatar){
        return user.avatar;
      }else{
        return require('@/assets/avatar.png');
      }

    },
    showConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-organizations'].show()
    },
    hideConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-organizations'].hide()
    },
    confirmDeleteTP(object) {
      let self = this;
      piincHttp.delete('organizations/' + object.slug).then(function() {
        self.hideConfirmDeleteModal();
        self.goToList();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('maintenance.organizations.delete.success'))
      }, function() {});
    },
    showEditTPModal(object) {

      this.error = ''
      let self = this;

      this.loadUsers();

      this.tpForm.slug = object.slug;
      this.tpForm.name = object.name;
      this.tpForm.description = object.description;

      this.selectedUsers = []
      if (object.users && object.users.length) {
        _.forEach(object.users, function (user) {
          self.selectedUsers.push(user)
        })
      }

      if (object.organization_level) {
        this.tpForm.organization_level = _.find(this.levelItems, function(item) {
          return item.value == object.organization_level;
        });
        this.showLinkOrganizations = object.organization_level == 1 ? false : true;
        this.asyncLoadLinkOrganizations();
        this.tpForm.link_organization = object.linkedOrganization;
      }

      this.$refs['edit-organization'].show()
    },
    hideEditTPModal() {
      this.$refs['edit-organization'].hide()
    },
    editTPFormSubmit(evt) {
      this.buttonDisabled = true;
      var moment = require('moment');
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();
      this.tpForm.client = this.getClient.slug;

      // Additional check
      if (this.tpForm.organization_level && this.tpForm.organization_level.value) {
        this.tpForm.organization_level = this.tpForm.organization_level.value;
      }

      this.tpForm.users = [];
      if (this.selectedUsers && this.selectedUsers.length) {
        for (var i = 0; i < this.selectedUsers.length; i++) {
          this.tpForm.users.push(this.selectedUsers[i].id);
        }
      }

      this.tpForm.link_organization = this.tpForm.link_organization ? this.tpForm.link_organization.id : '';

      piincHttp.put('organizations/' + this.tpForm.slug, this.tpForm).then(function(response) {
        self.hideEditTPModal();
        self.buttonDisabled = false;
        self.reloadContent(response.data)
        self.$router.push({ name: 'maintenance.organizations.view', params: { slug: response.data.slug }})
        self.$toastr('success', self.$t('maintenance.organizations.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
          if (error.data.errors.organization_level) {
            self.error += ' ' + error.data.errors.organization_level[0]
          }
        }
      })
    },
    reloadContent(object) {
      // If slug is not changed, just reload content
      if (object.slug == this.organization.slug) {
        // Remove last item in breadcrumbs, because it will be added again on load content
        this.breadcrumbItems.pop();
        this.loadContent(true);
      } else {
        this.$store.commit('storeUpdateTasks', true);
        // If slug changed, reload state with new param
        this.$router.push({ name: 'maintenance.organizations.view', params: { slug: object.slug }})
      }
    },
    loadUsers(query) {
      let self = this;
      piincHttp.get('users', { params:
        {
          client: this.getClient.id,
          keyword: query ? query : undefined,
          per_page: 50
        }
      }).then(function(response) {
        self.users = response.data.items
        if (self.users && !self.users.length && !query) {
          self.users.push({name: self.$t('system.no_results'), $isDisabled: true})
        }
      }, function() {});
    }
  },
  created () {
    this.loadContent(true)
    this.loadGuides('organization');
  }
}
</script>
